import { createReducer } from "@reduxjs/toolkit";
import { getAvvioCertificazione, getDettaglioCliente, getElencoCertificazioniCliente, getFlagButtonAvviaCertificazione, getInviaEmail, resetResultAvvioCertificazione } from "./actions";
import { DettaglioClienteReducerType } from "./types";



const initialState: DettaglioClienteReducerType = {
  flagButtonAvviaCertificazione: undefined,
  resultInvioEmail: undefined,
  dettaglioCliente: undefined,
  resultAvvioCertificazione: undefined,
  elencoCertificazioniCliente: [],
};

export const dettaglioClienteReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getFlagButtonAvviaCertificazione.pending, (state) => {
      state.flagButtonAvviaCertificazione = initialState.flagButtonAvviaCertificazione;
    })
    .addCase(getFlagButtonAvviaCertificazione.fulfilled, (state, action) => {
      state.flagButtonAvviaCertificazione = action.payload;
    })
    .addCase(getInviaEmail.pending, (state) => {
      state.resultInvioEmail = initialState.resultInvioEmail;
    })
    .addCase(getInviaEmail.fulfilled, (state, action) => {
      state.resultInvioEmail = action.payload;
    })
    .addCase(getAvvioCertificazione.pending, (state) => {
      state.resultAvvioCertificazione = initialState.resultAvvioCertificazione;
    })
    .addCase(getAvvioCertificazione.fulfilled, (state, action) => {
      state.resultAvvioCertificazione = action.payload;
    })
    .addCase(resetResultAvvioCertificazione, (state) => {
      state.resultAvvioCertificazione = initialState.resultAvvioCertificazione;
    })
    .addCase(getElencoCertificazioniCliente.pending, (state) => {
      state.elencoCertificazioniCliente = initialState.elencoCertificazioniCliente;
    })
    .addCase(getElencoCertificazioniCliente.fulfilled, (state, action) => {
      state.elencoCertificazioniCliente = action.payload || [];
    })
    .addCase(getDettaglioCliente.pending, (state) => {
      state.dettaglioCliente = initialState.dettaglioCliente;
    })
    .addCase(getDettaglioCliente.fulfilled, (state, action) => {
      state.dettaglioCliente = action.payload;
    })

});
